import { render, staticRenderFns } from "./projectConfig.vue?vue&type=template&id=64991fa7&"
import script from "./projectConfig.vue?vue&type=script&lang=js&"
export * from "./projectConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/projectConfig/projectConfig.vue"
export default component.exports